import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';

import { LbInput } from '@infoods/lifebase-ui';

import classes from './ExistAccountStep.module.scss';
import { AccountDetailsWidget } from '../../../../../../../customer-management';
import { InputBox } from '../../../../../../../shared/components/form-components';
import { ButtonRow } from '../../../../components/ButtonRow/ButtonRow';
import { challengeSignUpStore } from '../../../../../../stores/challengeSignUpStore';
import { challengeSignUpService } from '../../../../../../services/challengeSignUpService';

type FormValues = {
  nickName: string;
};

type ExistAccountStepProps = {
  onSuccessSubmit: () => void;
};

const ExistAccountStep = observer(({ onSuccessSubmit }: ExistAccountStepProps) => {
  const { customer, entityData } = challengeSignUpStore;

  const { participantId } = challengeSignUpStore;

  if (!participantId) {
    throw new Error('Participant ID is not defined');
  }

  const { control, handleSubmit } = useForm<FormValues>();

  const onSubmit = handleSubmit(async ({ nickName }) => {
    await challengeSignUpService.setNickname(participantId, nickName);

    onSuccessSubmit();
  });

  return (
    <>
      <div className={classes.container}>
        {customer && (
          <AccountDetailsWidget
            firstName={customer.firstName}
            lastName={customer.lastName}
            entityName={entityData?.entityName}
            inbodyId={customer.inbodyId}
            dateOfBirth={customer.dateOfBirth}
            gender={customer.gender}
          />
        )}
        <InputBox title="Personal Data">
          <LbInput
            control={control}
            size="small"
            variant="standard"
            name="nickName"
            label="Name displayed on the leaderboard"
            rules={{ required: 'Name displayed on the leaderboard is required' }}
          />
        </InputBox>
      </div>
      <ButtonRow yesText="Next Step" yesHandler={onSubmit} />
    </>
  );
});

export { ExistAccountStep };
